export const KeycloakKeyIds = {
  KC_TOKEN: 'kc_token',
  KC_REFRESH_TOKEN: 'kc_refreshToken',
  KC_SESSION_ID: 'kc_sessionId',
}

export const LS_LOCALE_KEY = `${import.meta.env.VITE_ENVIRONMENT}.locale`
